export default {
  agreement: '<0>Terms and Conditions</0> and <1>Privacy Policy.</1>',
  forgotPassword: 'Forgot your password?',
  heading: 'Sign in',
  or: 'or sign in with',
  rememberMe: 'Remember me',
  signup: 'Not a member? <0>Join free</0>',
  submit: 'Continue',
};
